"use strict";

import angular from "angular";

angular
    .module("nucont.accounting.company.department")
    .config(["$stateProvider", routeConfig]);

function routeConfig($stateProvider) {
    $stateProvider
        .state("nucont.accounting.company.department.financial", {
            url: "/financeiro"
        })
        .state("nucont.accounting.company.department.financial.import", {
            url: "/importar",
            views: {
                "tableDepartment@nucont.accounting.company.department": {
                    component: "departmentFinancialImportComponent",
                    bindings: { companyData: "CompanyData" }
                }
            },

            bodyClass: "department-module"
        })
        .state("nucont.accounting.company.department.financial.edit", {
            url: "/editar?accountPlan",
            views: {
                "tableDepartment@nucont.accounting.company.department": {
                    component: "departmentFinancialEditComponent",
                    bindings: { companyData: "CompanyData" }
                }
            },
            params: {
                parametrizationOpen: { value: null },
                accountPlan: { value: null, dynamic: true }
            },
            bodyClass: "department-module"
        })
        .state("nucont.accounting.company.department.financial.scenarios", {
            url: "/cenarios/:scenarioId",
            params: {
                scenarioId: { value: null, dynamic: true }
            },
            views: {
                "tableDepartment@nucont.accounting.company.department": {
                    component: "departmentFinancialScenariosComponent",
                    bindings: { companyData: "CompanyData" }
                }
            },
            bodyClass: "department-module"
        });
}
